class FaqSection {
  constructor(container) {
    this.container = container;
    this.categoryBtns = container.querySelectorAll('.faq-cat-btn');
    this.panels = container.querySelectorAll('.faq-panel');
    this.init();
  }

  init() {
    this.categoryBtns.forEach(btn => {
      btn.addEventListener('click', () => this.switchCategory(btn));
    });

    this.container.querySelectorAll('.faq-item__question').forEach(btn => {
      btn.addEventListener('click', () => this.toggleAnswer(btn));
    });
  }

  switchCategory(activeBtn) {
    const targetId = activeBtn.dataset.target;

    this.categoryBtns.forEach(btn => {
      const isActive = btn === activeBtn;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach(panel => {
      panel.classList.toggle('is-active', panel.id === targetId);
    });

    // On mobile, scroll so the FAQ list is visible
    if (window.innerWidth < 768) {
      const activePanel = this.container.querySelector('.faq-panel.is-active');
      if (activePanel) {
        const offset = activePanel.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    }
  }

  toggleAnswer(btn) {
    const answerId = btn.getAttribute('aria-controls');
    const answer = document.getElementById(answerId);
    if (!answer) return;

    const isExpanded = btn.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.closeAnswer(btn, answer);
    } else {
      this.openAnswer(btn, answer);
    }
  }

  openAnswer(btn, answer) {
    btn.setAttribute('aria-expanded', 'true');
    btn.querySelector('.faq-item__toggle-icon').textContent = '−';

    const inner = answer.querySelector('.faq-item__answer-inner');
    answer.style.maxHeight = inner.scrollHeight + 'px';

    answer.addEventListener('transitionend', () => {
      if (btn.getAttribute('aria-expanded') === 'true') {
        answer.style.maxHeight = 'none';
      }
    }, { once: true });
  }

  closeAnswer(btn, answer) {
    btn.setAttribute('aria-expanded', 'false');
    btn.querySelector('.faq-item__toggle-icon').textContent = '+';

    // Pin current height before collapsing
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.offsetHeight; // force reflow
    answer.style.maxHeight = '0px';
  }
}

function initFaqSections() {
  document.querySelectorAll('[data-faq-section]').forEach(el => {
    if (!el.dataset.faqInit) {
      el.dataset.faqInit = 'true';
      new FaqSection(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqSections);
} else {
  initFaqSections();
}

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target.querySelector('[data-faq-section]');
  if (container) {
    delete container.dataset.faqInit;
    new FaqSection(container);
  }
});
